import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles, ShieldCheck, Clock } from 'lucide-react';
import { Card, CardContent } from '../Card';
export function ValueProps() {
  const cards = [{
    icon: Sparkles,
    title: 'Heaven-Sent Clean',
    desc: "We don't just clean. We transform. Every surface treated like it belongs in a palace."
  }, {
    icon: ShieldCheck,
    title: 'Trustworthy & Vetted',
    desc: 'Our team is fully background-checked, bonded, and insured. We treat your home like our own.'
  }, {
    icon: Clock,
    title: 'Always On Time',
    desc: 'Punctual, professional, and consistent. We show up when we say we will, every time.'
  }];
  return <section className="py-24 bg-brand-white relative overflow-hidden" data-id="element-236">
      {/* Soft bokeh/cloud texture overlay */}
      <div className="absolute inset-0 opacity-30 pointer-events-none" style={{
      backgroundImage: 'radial-gradient(circle at 20% 30%, rgba(91, 143, 204, 0.1) 0%, transparent 50%), radial-gradient(circle at 80% 70%, rgba(212, 175, 106, 0.05) 0%, transparent 50%)'
    }} data-id="element-237" />

      <div className="container mx-auto px-4 relative z-10" data-id="element-238">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} className="text-center mb-16" data-id="element-239">
          <h2 className="font-serif text-4xl md:text-5xl text-brand-charcoal" data-id="element-240">
            Why Maid In Heaven?
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto" data-id="element-241">
          {cards.map((card, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          delay: index * 0.2,
          duration: 0.6
        }} data-id="element-242">
              <Card className="bg-brand-lavender/50 border-none shadow-soft hover:shadow-soft-lg transition-shadow duration-300 rounded-[16px] h-full" data-id="element-243">
                <CardContent className="p-8 text-center flex flex-col items-center" data-id="element-244">
                  <div className="w-16 h-16 rounded-full bg-white flex items-center justify-center mb-6 shadow-sm" data-id="element-245">
                    <card.icon className="w-8 h-8 text-brand-gold" data-id="element-246" />
                  </div>
                  <h3 className="font-serif text-2xl text-brand-charcoal mb-4" data-id="element-247">
                    {card.title}
                  </h3>
                  <p className="text-brand-charcoal/70 leading-relaxed" data-id="element-248">
                    {card.desc}
                  </p>
                </CardContent>
              </Card>
            </motion.div>)}
        </div>
      </div>
    </section>;
}